import React from 'react';
import { Box } from 'theme-ui';

export function StarRating({ rating = 5, size = 16, color = '#FFD700' }) {
  // Clamp rating between 0 and 5
  const clampedRating = Math.max(0, Math.min(5, rating));
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
        justifyContent: 'center',
      }}
      role="img"
      aria-label={`${rating} out of 5 stars`}
    >
      {[...Array(5)].map((_, index) => (
        <Box
          key={index}
          sx={{
            width: size,
            height: size,
            color: index < clampedRating ? color : '#E5E5E5',
          }}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
          </svg>
        </Box>
      ))}
    </Box>
  );
}
